<template>
  <div id="app">
    <body>
      <router-view/>
    </body>
    <error-popup v-show="isLoaded"/>
    <loading-status v-show="$store.state.loading['showCheck']"/>
  </div>
</template>

<script>
import ErrorPopup from '@/components/popup/ErrorPopup'
import LoadingStatus from '@/components/LoadingStatus'
import { router } from '@/router/router'
import { store } from '@/store'
  export default {
    name: 'app',
    data() {
      return {
        // currentLayout: ''
        isLoaded: false
      }
    },
    components: {
      ErrorPopup,
      LoadingStatus
    },
    created() {
      // 브라우저 체크 로직 추가
      // IE 10, 9, 8 지원 안해서 닫게 변경
      let userAgent = navigator.userAgent
      if (userAgent.indexOf('MSIE') >= 0) {
        alert('현재 브라우저에서는 가입이 원활하지 않을 수 있습니다.\n브라우저를 업데이트 하시거나, Chrome, Safari 등의 브라우저를 이용해주시기 바랍니다.')
        window.close()
        return false
      }

      // 현재 접근한 디바이스가 모바일인지 검사
      var filter = "win16|win32|win64|mac";
      if(navigator.platform){
        if(0 > filter.indexOf(navigator.platform.toLowerCase())){
          this.$store.state.isMobile = true
        }else{
          this.$store.state.isMobile = false
        }
      }

      // https로 리다이렉트
      let originHref = window.location.href
      if (window.location.protocol !== 'https:') window.location.href = originHref.replace('http:','https:')
    },
    mounted() {
      setTimeout(() => {
        this.isLoaded = true
      }, 200)

    },
    computed: {},
    methods: {
    },
  }
</script>

<style src="~/css/pc.css"/>
<style src="~/css/modal.css"/>
<style media="screen and (max-width: 10240)" src="~/css/pad.css"/>
<style media="screen and (max-width: 600)" src="~/css/mobile.css"/>
<style>

</style>
